module.exports = __webpack_public_path__ + "e28a98b521570c9024e0c585a51fa08e.png";